module.exports = __webpack_public_path__ + "static/hoststyling-ca65d2d71750d28bf2f042afa659b955.png";